import { render } from "./AdminDiscounts.vue?vue&type=template&id=7a17fd80"
import script from "./AdminDiscounts.vue?vue&type=script&lang=js"
export * from "./AdminDiscounts.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__